import { useEffect, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  NavLink,
  useNavigate,
} from "react-router-dom";

import "./housestyle.css";
import logo from "./Media/logo.png";
import api from "./API/Api";

import Home from "./Home/Home";
import Apply from "./Apply/Apply";
import Blogs from "./Blogs/Blogs";
import BlogPost from "./Blogs/BlogPost";
import Rules from "./Rules/Rules";
import StaffPage from "./Staff/Staff";
import GiveawayPage from "./Giveaways/Giveaways";
import Ranks from "./Ranks/Ranks";
import SeasonInfo from "./SeasonInfo/SeasonInfo";
import Wiki from "./Wiki/Wiki";

function DiscountBanner() {
  const [sale, setSale] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    api("getsale").then((res) => {
      if (res.isSuccess && res.data) setSale(res.data);
    });
  }, []);

  if (!sale?.active) return null;

  function copy() {
    navigator.clipboard.writeText(sale.code).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }

  return (
    <div className="discount-banner">
      {sale.label && <span className="discount-banner-text">{sale.label}</span>}
      <button className="discount-code-chip" onClick={copy}>
        {sale.code}
        <span className="discount-code-chip-copy">
          {copied ? "Copied!" : "Copy"}
        </span>
      </button>
        {/* <span className="discount-banner-label">~ Sale on ranks use code</span> */}
    </div>
  );
}

function ComingSoon({ title }) {
  return (
    <div style={{ padding: "4rem 2rem", textAlign: "center" }}>
      <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>🚧</div>
      <h2 style={{ fontSize: "var(--t-2xl)", marginBottom: "0.5rem" }}>
        {title}
      </h2>
      <p style={{ color: "var(--text-muted)", fontSize: "var(--t-sm)" }}>
        This page is coming soon.
      </p>
    </div>
  );
}

const NAV = [
  { path: "/", label: "Home" },
  { path: "/giveaways", label: "Giveaways" },
  // { path: "/wiki", label: "Wiki" },
  { path: "/blogs", label: "Blogs" },
  { path: "/our-staff", label: "Staff" },
  { path: "/rules", label: "Rules" },
  { path: "/apply", label: "Apply" },
  { path: "/ranks", label: "Ranks" },
  { path: "/SeasonInfo", label: "Season Info" },
];

function Navbar() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <nav className="navbar">
        <div
          className="navbar-brand"
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        >
          <img src={logo} alt="SimpleMC Logo" width={"70px"} />
        </div>

        <div className="navbar-links">
          {NAV.map(({ path, label }) => (
            <NavLink
              key={path}
              to={path}
              end={path === "/"}
              className={({ isActive }) =>
                `nav-link${isActive ? " active" : ""}`
              }
            >
              {label}
            </NavLink>
          ))}
        </div>

        <button
          onClick={() =>
            window.open("https://discord.com/invite/simplemc", "_blank")
          }
          className="nav-discord desktop-only"
        >
          Join Discord
        </button>

        <button
          className="nav-hamburger"
          onClick={() => setMenuOpen((o) => !o)}
        >
          <span />
          <span />
          <span />
        </button>
      </nav>

      {menuOpen && (
        <div className="nav-mobile-drawer">
          {NAV.map(({ path, label }) => (
            <NavLink
              key={path}
              to={path}
              end={path === "/"}
              className={({ isActive }) =>
                `nav-mobile-link${isActive ? " active" : ""}`
              }
              onClick={() => setMenuOpen(false)}
            >
              {label}
            </NavLink>
          ))}
          <button
            onClick={() => {
              window.open("https://discord.com/invite/simplemc", "_blank");
              setMenuOpen(false);
            }}
            className="nav-discord"
            style={{ width: "100%", justifyContent: "center" }}
          >
            Join Discord
          </button>
        </div>
      )}
    </>
  );
}

function Layout() {
  useEffect(() => {
    const last = localStorage.getItem("lastVisit");
    const now = Date.now();
    if (!last || now - last > 300000) {
      localStorage.setItem("lastVisit", now);
      api("recordvisit");
    }
  }, []);

  return (
    <div>
      <Navbar />
      <DiscountBanner />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/SeasonInfo" element={<SeasonInfo />} />
          <Route path="/ranks" element={<Ranks />} />
          {/* <Route path="/wiki" element={<Wiki />} /> */}
          <Route path="/apply" element={<Apply />} />
          <Route path="/rules" element={<Rules />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:id" element={<BlogPost />} />
          <Route path="/our-staff" element={<StaffPage />} />
          <Route path="/giveaways" element={<GiveawayPage />} />
          <Route path="*" element={<ComingSoon title="Page Not Found" />} />
        </Routes>
      </main>
      <footer className="site-footer">
        <div className="footer-brand">SimpleMC</div>
        <p>Survival SMP · simplemcnetwork.net · Season 1</p>
      </footer>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}
